import * as Button from "../../../src/Components/Button/Button.scss";
import { Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { union_type, record_type, option_type, list_type, bool_type, lambda_type, unit_type, class_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { SaveStatus, SaveStatus$reflection } from "../../Global.js";
import { classNames, logi } from "../../Utils.js";
import { singleton as singleton_1, head, tail as tail_1, isEmpty, ofArray, map, append, empty } from "../../fable_modules/fable-library.3.7.20/List.js";
import { singleton, append as append_1, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { uncurry, equals } from "../../fable_modules/fable-library.3.7.20/Util.js";
import * as react from "react";
import { Size, SveaIcon, renderSveaIconBySize, getMaterialIcon, getWrappedMaterialIcon } from "../../ViewUtils.js";
import { DOMAttr, HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { effect } from "../Hooks/ClickOutside.js";


export class ButtonProps extends Record {
    constructor(Text$, Content, OnClick, Disabled, Id, SaveStatus, HTMLProps, ExtraClasses, Icon) {
        super();
        this.Text = Text$;
        this.Content = Content;
        this.OnClick = OnClick;
        this.Disabled = Disabled;
        this.Id = Id;
        this.SaveStatus = SaveStatus;
        this.HTMLProps = HTMLProps;
        this.ExtraClasses = ExtraClasses;
        this.Icon = Icon;
    }
}

export function ButtonProps$reflection() {
    return record_type("Components.Button.ButtonProps", [], ButtonProps, () => [["Text", string_type], ["Content", class_type("Fable.React.ReactElement")], ["OnClick", lambda_type(class_type("Browser.Types.MouseEvent", void 0, MouseEvent), unit_type)], ["Disabled", bool_type], ["Id", string_type], ["SaveStatus", SaveStatus$reflection()], ["HTMLProps", list_type(class_type("Fable.React.Props.IHTMLProp"))], ["ExtraClasses", list_type(string_type)], ["Icon", option_type(string_type)]]);
}

export function ButtonProps_get_getDefault() {
    return new ButtonProps("", "", (_arg) => {
        logi("Button clicked, needs override.");
    }, false, "", new SaveStatus(0), empty(), empty(), void 0);
}

export const defaultProps = ButtonProps_get_getDefault();

export class ButtonKind extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Main", "Secondary", "Cancel", "Terminate", "ModalMain", "ModalCancel"];
    }
}

export function ButtonKind$reflection() {
    return union_type("Components.Button.ButtonKind", [], ButtonKind, () => [[], [], [], [], [], []]);
}

function getButton(props, buttonKind) {
    let children_2, children_14, children_18, children_6;
    const classes_1 = classNames(append(toList(delay(() => append_1(singleton(["button", true]), delay(() => append_1(singleton(["button--main", equals(buttonKind, new ButtonKind(0))]), delay(() => append_1(singleton(["button--second", equals(buttonKind, new ButtonKind(1))]), delay(() => append_1(singleton(["button--cancel", equals(buttonKind, new ButtonKind(2))]), delay(() => append_1(singleton(["button--terminate", equals(buttonKind, new ButtonKind(3))]), delay(() => append_1(singleton(["button__modal--main", equals(buttonKind, new ButtonKind(4))]), delay(() => append_1(singleton(["button__modal--cancel", equals(buttonKind, new ButtonKind(5))]), delay(() => {
        const matchValue = props.SaveStatus;
        switch (matchValue.tag) {
            case 1: {
                return singleton(["", false]);
            }
            case 2: {
                return singleton(["button--green", true]);
            }
            case 3: {
                return singleton(["button--red", true]);
            }
            default: {
                return singleton(["", false]);
            }
        }
    })))))))))))))))), map((classStr) => [classStr, true], props.ExtraClasses)));
    let buttonLoadingSpinnerHtml;
    const children_4 = [(children_2 = [react.createElement("span", {
        className: "sr-only",
    }, "Loading...")], react.createElement("div", {
        className: "spinner-border",
        role: "status",
    }, ...children_2))];
    buttonLoadingSpinnerHtml = react.createElement("div", {
        className: "d-flex justify-content-center",
    }, ...children_4);
    let buttonContents;
    const matchValue_1 = props.SaveStatus;
    switch (matchValue_1.tag) {
        case 1: {
            const children_12 = [react.createElement("span", {
                className: "mr-2",
            }, buttonLoadingSpinnerHtml), props.Text, props.Content];
            buttonContents = react.createElement("span", {
                className: "d-flex align-items-center justify-content-center",
            }, ...children_12);
            break;
        }
        case 2: {
            const children_16 = [(children_14 = [getWrappedMaterialIcon("done")], react.createElement("span", {
                className: "mr-2",
            }, ...children_14)), props.Text, props.Content];
            buttonContents = react.createElement("span", {
                className: "d-flex align-items-center justify-content-center",
            }, ...children_16);
            break;
        }
        case 3: {
            const children_20 = [(children_18 = [getWrappedMaterialIcon("clear")], react.createElement("span", {
                className: "mr-2",
            }, ...children_18)), props.Text, props.Content];
            buttonContents = react.createElement("span", {
                className: "d-flex align-items-center justify-content-center",
                title: matchValue_1.fields[0],
            }, ...children_20);
            break;
        }
        default: {
            const matchValue_2 = props.Icon;
            if (matchValue_2 != null) {
                const children_8 = [(children_6 = [getWrappedMaterialIcon(matchValue_2)], react.createElement("span", {
                    className: "mr-2",
                }, ...children_6)), props.Text, props.Content];
                buttonContents = react.createElement("span", {
                    className: "d-flex align-items-center justify-content-center",
                }, ...children_8);
            }
            else {
                buttonContents = ((props.Text === "") ? props.Content : props.Text);
            }
        }
    }
    const props_23 = append(ofArray([new HTMLAttr(159, "button"), new HTMLAttr(99, props.Id), new HTMLAttr(65, classes_1), new HTMLAttr(79, props.Disabled), new DOMAttr(40, props.OnClick)]), props.HTMLProps);
    return react.createElement("button", keyValueList(props_23, 1), buttonContents);
}

export function main(props) {
    return getButton(props, new ButtonKind(0));
}

export function secondary(props) {
    return getButton(props, new ButtonKind(1));
}

export function cancel(props) {
    return getButton(props, new ButtonKind(2));
}

export function terminate(props) {
    return getButton(props, new ButtonKind(3));
}

export function modalMain(props) {
    return getButton(props, new ButtonKind(4));
}

export function modalCancel(props) {
    return getButton(props, new ButtonKind(5));
}

export function wrappedButton(kind, props) {
    const children = [getButton(props, kind)];
    return react.createElement("div", {
        className: "fit-content",
    }, ...children);
}

export class SplitButtonProps extends Record {
    constructor(Buttons) {
        super();
        this.Buttons = Buttons;
    }
}

export function SplitButtonProps$reflection() {
    return record_type("Components.Button.SplitButtonProps", [], SplitButtonProps, () => [["Buttons", list_type(ButtonProps$reflection())]]);
}

export const splitButton = FunctionComponent_Of_Z5A158BBF((props) => {
    let classes, children_8;
    const subMenuIsVisibleState = react.useState(false);
    const containerRef = react.useRef(void 0);
    react.useEffect(() => {
        const disp = (() => effect(containerRef, () => {
        subMenuIsVisibleState[1](false);
    }, void 0))();
        return () => disp.Dispose();
    });
    const renderPrimaryButton = (buttonProps) => {
        let children_2;
        const props_5 = append(ofArray([new HTMLAttr(159, "button"), new HTMLAttr(99, buttonProps.Id), new HTMLAttr(65, "split-button--first"), new HTMLAttr(79, buttonProps.Disabled), new DOMAttr(40, (value) => {
        })]), buttonProps.HTMLProps);
        const children_4 = [react.createElement("div", {
            className: "split-button__contents",
            onClick: buttonProps.OnClick,
        }, buttonProps.Text), (children_2 = [getMaterialIcon("expand_more")], react.createElement("div", {
            className: "split-button__expand",
            onClick: (_arg) => {
                subMenuIsVisibleState[1]((value_1) => (!value_1));
            },
        }, ...children_2))];
        return react.createElement("button", keyValueList(props_5, 1), ...children_4);
    };
    let subElementsHtml;
    const matchValue = props.Buttons;
    subElementsHtml = ((!isEmpty(matchValue)) ? (isEmpty(tail_1(matchValue)) ? singleton_1(renderPrimaryButton(head(matchValue))) : ofArray([renderPrimaryButton(head(matchValue)), (classes = classNames(ofArray([["split-button__dropdown", true], ["d-none", !(subMenuIsVisibleState[0])]])), (children_8 = map((buttonProps_1) => {
        const htmlProps = append(ofArray([new HTMLAttr(65, "dropdown__item"), new DOMAttr(40, (event) => {
            buttonProps_1.OnClick(event);
            subMenuIsVisibleState[1](false);
        }), new HTMLAttr(79, buttonProps_1.Disabled)]), buttonProps_1.HTMLProps);
        return react.createElement("button", keyValueList(htmlProps, 1), buttonProps_1.Text);
    }, tail_1(matchValue)), react.createElement("div", {
        className: classes,
    }, ...children_8)))])) : empty());
    return react.createElement("div", {
        className: "split-button",
        ref: containerRef,
    }, ...subElementsHtml);
}, void 0, uncurry(2, void 0), void 0, "splitButton", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Components\\Button\\Button.fs", 181);

export class DropDownButtonProps extends Record {
    constructor(Id, Text$, Buttons) {
        super();
        this.Id = Id;
        this.Text = Text$;
        this.Buttons = Buttons;
    }
}

export function DropDownButtonProps$reflection() {
    return record_type("Components.Button.DropDownButtonProps", [], DropDownButtonProps, () => [["Id", string_type], ["Text", string_type], ["Buttons", list_type(ButtonProps$reflection())]]);
}

export function DropDownButtonProps_get_GetDefault() {
    return new DropDownButtonProps("", "", empty());
}

export const dropDownButton = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_4, children_2, classes, children_8;
    const subMenuIsVisibleState = react.useState(false);
    const containerRef = react.useRef(void 0);
    react.useEffect(() => {
        const disp = (() => effect(containerRef, () => {
        subMenuIsVisibleState[1](false);
    }, void 0))();
        return () => disp.Dispose();
    });
    let subElementsHtml;
    const matchValue = props.Buttons;
    subElementsHtml = (isEmpty(matchValue) ? empty() : ofArray([(children_4 = [react.createElement("div", {
        className: "dropdown-button__contents",
    }, props.Text), (children_2 = [renderSveaIconBySize(new SveaIcon(13), new Size(1))], react.createElement("div", {
        className: "dropdown-button__expand",
    }, ...children_2))], react.createElement("button", {
        type: "button",
        id: props.Id,
        className: "dropdown-button--first",
        onClick: (event) => {
            event.stopPropagation();
            subMenuIsVisibleState[1]((value) => (!value));
        },
    }, ...children_4)), (classes = classNames(ofArray([["dropdown-button__dropdown", true], ["d-none", !(subMenuIsVisibleState[0])]])), (children_8 = map((buttonProps) => {
        const htmlProps = append(ofArray([new HTMLAttr(65, "dropdown__item"), new DOMAttr(40, (event_1) => {
            event_1.stopPropagation();
            buttonProps.OnClick(event_1);
            subMenuIsVisibleState[1](false);
        }), new HTMLAttr(79, buttonProps.Disabled)]), buttonProps.HTMLProps);
        return react.createElement("button", keyValueList(htmlProps, 1), buttonProps.Text);
    }, matchValue), react.createElement("div", {
        className: classes,
    }, ...children_8)))]));
    return react.createElement("div", {
        className: "dropdown-button",
        ref: containerRef,
    }, ...subElementsHtml);
}, void 0, uncurry(2, void 0), void 0, "dropDownButton", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Components\\Button\\Button.fs", 247);

